import { createContext, useContext, type ReactNode } from 'react';
import { useConversionTriggers, type NudgeConfig } from '../hooks/useConversionTriggers';

interface ConversionTriggersCtx {
  activeNudge: NudgeConfig | null;
  dismissNudge: () => void;
  handleUpgradeClick: () => void;
  trackLimitHit: (resource: string) => void;
  trackFeatureBlock: (feature: string) => void;
  trackTransactionCreated: () => void;
  trackReportView: () => void;
}

const ConversionContext = createContext<ConversionTriggersCtx>({
  activeNudge: null,
  dismissNudge: () => {},
  handleUpgradeClick: () => {},
  trackLimitHit: () => {},
  trackFeatureBlock: () => {},
  trackTransactionCreated: () => {},
  trackReportView: () => {},
});

export const ConversionTriggersProvider = ({ children }: { children: ReactNode }) => {
  const triggers = useConversionTriggers();
  return (
    <ConversionContext.Provider value={triggers}>
      {children}
    </ConversionContext.Provider>
  );
};

export const useConversionContext = () => useContext(ConversionContext);
